import { render, staticRenderFns } from "./VTitle.vue?vue&type=template&id=04d88b20&"
import script from "./VTitle.vue?vue&type=script&lang=js&"
export * from "./VTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports